import { TYPE_OF_DAMAGE } from '@/api/types';
import { ConditionalRender } from '@/components/ui/ConditionalRender';
import { useStepper } from '@/features/v2/lib/stepper';
import {
  HAS_DAMAGE_PHOTOS,
  HAS_DAMAGE_PHOTOS_NAME,
} from '@/features/v2/vehicle-damage/components/RadioGroupHasDamagePhotos';
import { HOW_WAS_DAMAGE_ESTIMATED_NAME } from '@/features/v2/vehicle-damage/components/RadioGroupHowWasDamageEstimated';
import { TYPE_OF_DAMAGE_NAME } from '@/features/v2/vehicle-damage/components/RadioGroupTypeOfDamage';
import { FullAC } from '@/features/v2/vehicle-damage/surveys/SurveyTwo/FullAC';
import { FullOC } from '@/features/v2/vehicle-damage/surveys/SurveyTwo/FullOC';
import { PartAC } from '@/features/v2/vehicle-damage/surveys/SurveyTwo/PartAC';
import { PartOC } from '@/features/v2/vehicle-damage/surveys/SurveyTwo/PartOC';

export const SurveyTwo = () => {
  const { innerStep } = useStepper();

  return (
    <ConditionalRender
      when={(val) =>
        val[HAS_DAMAGE_PHOTOS_NAME] === HAS_DAMAGE_PHOTOS.YES ||
        !!val[HOW_WAS_DAMAGE_ESTIMATED_NAME]
      }
    >
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.PART_OC}
      >
        <PartOC innerStep={innerStep} />
      </ConditionalRender>
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.FULL_OC}
      >
        <FullOC innerStep={innerStep} />
      </ConditionalRender>{' '}
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.PART_AC}
      >
        <PartAC innerStep={innerStep} />
      </ConditionalRender>
      <ConditionalRender
        when={(val) => val[TYPE_OF_DAMAGE_NAME] === TYPE_OF_DAMAGE.FULL_AC}
      >
        <FullAC innerStep={innerStep} />
      </ConditionalRender>
    </ConditionalRender>
  );
};
